/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unstable-nested-components */
import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalActions,
  Button,
  ModalContent,
  ModalDescription,
  //Table,
  Checkbox,
  Input,
  Icon,
  Dropdown
} from 'semantic-ui-react';
import { Table, Column, AutoSizer } from 'react-virtualized';
import { v4 as uuidv4 } from 'uuid';
import cx from 'classnames';
import Update from 'immutability-helper';
import debounce from 'lodash/debounce';
import 'react-virtualized/styles.css';
import api from '../../api';
import ResultRenderer from '../ResultRenderer/ResultRenderer';
import './Virtualized.css';

class EditCveCodeModal extends Component {
  debouncedSearchRisk = debounce((value) => {
    this.searchRisk(value, 'risk');
  }, 1000);

  debouncedSearchCveCodeWithRisk = debounce((value) => {
    this.searchCveCodeWithRisk(value, 'code');
  }, 1000);

  constructor(props) {
    super(props);
    this.typingTimeout = null;
    this.riskData = [
      { id: 0, name: 'Critical', value: 'critical' },
      { id: 1, name: 'High', value: 'high' },
      { id: 2, name: 'Medium', value: 'medium' },
      { id: 3, name: 'Low', value: 'low' },
    ];
    this.state = {
      cveList: [],
      resultList: [],
      revertList: [],
      riskList: [],
      selectedResultData: {},
      selectedRowIds: [],
      activeIndex: '',
      currentId: '',
      errorMessage: '',
      limit: 25,
      allSelected: false,
    };
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlurOnRisk = this.handleBlurOnRisk.bind(this);
    this.handleBlurOnCve = this.handleBlurOnCve.bind(this);
    this.handleResultSelect = this.handleResultSelect.bind(this);
    this.handleResultSelectWithRisk = this.handleResultSelectWithRisk.bind(this);
    this.handleDeleteRowWithRisk = this.handleDeleteRowWithRisk.bind(this);
    this.handleAddRowWithRisk = this.handleAddRowWithRisk.bind(this);
    this.handleCheckAllChange = this.handleCheckAllChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      isOpenCVE,
      cveList
    } = this.props;

    if (isOpenCVE !== prevProps.isOpenCVE) {
      this.setState({
        cveList,
        revertList: JSON.parse(JSON.stringify(cveList)),
        allSelected: false,
        activeIndex: '',
        currentId: '',
        errorMessage: '',
        selectedRowIds: [],
        selectedResultData: {},
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.typingTimeout);
  }

  handleDeleteRowWithRisk(id) {
    const { cveList, selectedRowIds } = this.state;

    let newData;
    if (id) {
      newData = cveList.filter((item) => { return item.id !== id; });
    } else {
      newData = cveList.filter((item) => { return !selectedRowIds.includes(item.id); });
    }

    this.setState({
      cveList: newData,
      revertList: newData,
      allSelected: false,
    });
  }

  handleAddRowWithRisk() {
    const { cveList } = this.state;
    const customIds = [];

    const existIds = cveList.map((item) => {
      return item.id;
    });

    while (customIds.length < 1) {
      const r = uuidv4();
      if (existIds.indexOf(r) === -1) {
        customIds.push(r);
      }
    }

    const newData = {
      id: customIds[0],
      code: '',
      risk: 'critical',
      disabled: true,
    };

    this.setState({
      cveList: Update(cveList, {
        $unshift: [newData],
      }),
    });
  }

  handleCheckChange(e, { value }) {
    const { selectedRowIds, cveList } = this.state;
    let newState;

    if (selectedRowIds.includes(value)) {
      newState = selectedRowIds.filter((el) => { return el !== value; });
    } else {
      newState = [...selectedRowIds, value];
      if (newState.length === cveList.length) {
        this.setState({
          allSelected: true,
        });
      }
    }

    this.setState({
      selectedRowIds: newState,
      allSelected: newState.length === cveList.length,
    });
  }

  handleCheckAllChange() {
    const { cveList, allSelected } = this.state;
    if (allSelected) {
      return this.setState({
        selectedRowIds: [],
        allSelected: false,
      });
    }
    const newState = cveList.map((item) => {
      return item.id;
    });

    this.setState({
      selectedRowIds: newState,
      allSelected: true,
    });
  }

  onSubmit = () => {
    const { updateCallback } = this.props;
    const { cveList } = this.state;

    const seenCodes = {};

    const uniqueCveList = cveList.filter((cve) => {
      if (!seenCodes[cve.code]) {
        seenCodes[cve.code] = true;
        return true;
      }
      return false;
    });

    if (!this.validateForm(uniqueCveList)) {
      return;
    }

    updateCallback(uniqueCveList);
    this.closeModal();
  };

  handleChange = (id, dataType, value) => {
    const { cveList } = this.state;
    const newValue = value.trim();
    const updatedIndex = cveList.findIndex((item) => { return item.id === id; });

    const updateField = dataType === 'risk' ? 'risk' : 'code';
    const updatedValue = dataType === 'risk' ? newValue.toLowerCase() : newValue.toUpperCase();

    const updatedData = Update(cveList[updatedIndex], {
      [updateField]: { $set: updatedValue }
    });

    const updatedList = Update(cveList, {
      $splice: [[updatedIndex, 1, updatedData]]
    });

    this.setState({
      cveList: updatedList,
      resultList: [],
      activeIndex: '',
      currentId: id
    });

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    this.typingTimeout = setTimeout(() => {
      if (dataType === 'risk') {
        this.debouncedSearchRisk(updatedValue, id);
      } else if (dataType === 'code') {
        this.debouncedSearchCveCodeWithRisk(updatedValue);
      }
    }, 300);
  };

  handleFocus = (id, dataType, value) => {
    const { cveList, revertList } = this.state;
    const currentIndex = cveList.findIndex((item) => { return item.id === id; });
    const revertIndex = revertList.findIndex((item) => { return item.id === id; });

    if (currentIndex === -1 || revertIndex === -1) {
      setTimeout(() => {
        this.setState({
          currentId: id,
          selectedResultData: {},
          activeIndex: ''
        }, () => {
          if (dataType === 'risk') {
            this.searchRisk(value, dataType);
          } else if (dataType === 'code') {
            this.searchCveCodeWithRisk(value, dataType);
          }
        });
      }, 300);
      return;
    }

    let newData;
    let searchKeyword = '';

    if (cveList[currentIndex][dataType] === revertList[revertIndex][dataType]) {
      const updatedData = Update(cveList[currentIndex], {
        [dataType]: { $set: '' }
      });
      newData = Update(cveList, { $splice: [[currentIndex, 1, updatedData]] });
    } else {
      newData = cveList;
      searchKeyword = value;
    }

    setTimeout(() => {
      this.setState({
        cveList: newData,
        currentId: id,
        selectedResultData: {},
        activeIndex: ''
      }, () => {
        if (dataType === 'risk') {
          this.searchRisk(searchKeyword, dataType);
        } else if (dataType === 'code') {
          this.searchCveCodeWithRisk(searchKeyword, dataType);
        }
      });
    }, 300);
  };

  handleBlurOnRisk = (id) => {
    const {
      selectedResultData,
      cveList,
      revertList
    } = this.state;

    const editingIndex = cveList.findIndex((item) => {
      return item.id === id;
    });
    const revertIndex = revertList.findIndex((item) => {
      return item.id === id;
    });

    const initailObject = revertList[revertIndex];

    if (!initailObject) {
      return this.setState({
        currentId: id,
        activeIndex: '',
      });
    }

    if (Object.keys(selectedResultData).length === 0) {
      const isDuplicate = this.riskData.some((item) => { return item.value === cveList[editingIndex].risk; });
      if (cveList[editingIndex].risk === '' || !isDuplicate) {
        return this.setState({
          currentId: id,
          activeIndex: '',
          cveList: Update(cveList, {
            [editingIndex]: {
              risk: { $set: 'critical' },
            },
          }),
        });
      }
    }

    return this.setState({
      currentId: id,
      activeIndex: '',
      selectedResultData: {},
    });

  };

  handleBlurOnCve = (id) => {
    const {
      cveList,
      selectedResultData,
      revertList,
      resultList,
    } = this.state;

    const editingIndex = cveList.findIndex((item) => {
      return item.id === id;
    });
    const revertIndex = revertList.findIndex((item) => {
      return item.id === id;
    });

    const initailObject = revertList[revertIndex];

    if (!initailObject) {
      return this.setState({
        currentId: id,
        activeIndex: '',
      });
    }

    if (Object.keys(selectedResultData).length === 0) {
      if (cveList[editingIndex].code === '') {
        return this.setState({
          currentId: id,
          activeIndex: '',
          cveList: Update(cveList, {
            [editingIndex]: {
              code: { $set: initailObject.code },
            },
          }),
        });
      }
      const checkUnknownName = resultList.filter((item) => {
        return item.code === cveList[editingIndex].code;
      });
      if (checkUnknownName.length !== 0 && checkUnknownName[0].id === 'exact') {
        return this.setState({
          currentId: id,
          activeIndex: '',
          componentList: Update(cveList, {
            [editingIndex]: {
              code: { $set: initailObject.code },
            },
          }),
        });
      }

      return this.setState({
        currentId: id,
        activeIndex: '',
      });
    }
    return this.setState({
      currentId: id,
      activeIndex: '',
      selectedResultData: {},
    });
  };

  handleResultSelectWithRisk = (e, result) => {
    const { currentId, cveList } = this.state;

    const currentIndex = cveList.findIndex((item) => {
      return item.id === currentId;
    });

    this.setState({
      cveList: Update(cveList, {
        [currentIndex]: {
          risk: { $set: result.value },
        },
      }),
      activeIndex: '',
      selectedResultData: result,
      currentId: '',
    });
  };

  handleResultSelect = (e, result) => {
    const { currentId, cveList } = this.state;
    const currentIndex = cveList.findIndex((item) => { return item.id === currentId; });

    if (currentIndex === -1) {
      console.error('Selected CVE not found in the list.');
      return;
    }

    const updatesForCveList = {
      [currentIndex]: {
        [result.data_type]: { $set: result.name },
        risk: { $set: result.risk },
      }
    };

    if (result.data_type === 'code') {
      const shouldUpdate = this.findCVEByCode(result.name, currentIndex);
      if (shouldUpdate) {
        updatesForCveList[currentIndex].disabled = { $set: result.id !== 'exact' };
      }
    }

    this.setState((prevState) => {
      return {
        ...prevState,
        activeIndex: '',
        selectedResultData: result,
        currentId: '',
        cveList: Update(prevState.cveList, updatesForCveList),
      };
    });
  };

  capitalize = (str) => {
    return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
  };

  validateForm(array) {
    const { translate } = this.props;
    const newData = array.filter((item) => {
      return item.code === '';
    });

    if (newData.length !== 0) {
      this.setState({
        errorMessage: translate('modal.error.error_cve_required'),
      });
      return false;
    }
    return true;
  }

  findCVEByCode(code, index) {
    const { revertList } = this.state;
    if (revertList.length === 0) {
      return true;
    }
    if (!revertList[index].code) {
      return true;
    }
    return revertList[index].code !== code;
  }

  searchRisk(searchKeyword, dataType) {
    const { currentId } = this.state;
    const newText = searchKeyword.toLowerCase().replace(/\s/g, '') || '';

    const filteredData = this.riskData.filter((item) => {
      return item.name.toLowerCase().includes(newText);
    });

    this.setState({
      riskList: filteredData,
      activeIndex: `${dataType}_${currentId}`,
    });
  }

  searchCveCodeWithRisk(searchKeyword, dataType) {
    const { limit, currentId } = this.state;
    const newText = searchKeyword.replace(/\s/g, '') || '';
    api
      .searchCveCodeWithRisk({
        search: newText,
        limit,
      })
      .then((response) => {
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            id: index,
            name: item.code,
            risk: item.risk,
            data_type: dataType,
          };
        });

        if (newText !== '') {
          const isDuplicate = data.some((item) => { return item.code === newText; });
          if (!isDuplicate) {
            const newComponent = {
              id: 'exact',
              name: newText,
              risk: 'critical',
              data_type: dataType,
            };
            newData.unshift(newComponent);
          }
        }

        this.setState({
          activeIndex: `${dataType}_${currentId}`,
          resultList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  closeModal() {
    const { closeModal } = this.props;
    closeModal();
  }

  render() {
    const {
      isOpenCVE,
      translate
    } = this.props;
    const {
      resultList,
      activeIndex,
      cveList,
      riskList,
      selectedRowIds,
      allSelected,
      errorMessage,
    } = this.state;

    const renderIndeterminate = () => {
      return selectedRowIds.length > 0 && selectedRowIds.length < cveList.length;
    };

    const globalErrorClass = errorMessage !== '' ? 'show' : '';

    return (
      <Modal
        className="edit_cve_modal"
        open={isOpenCVE}
        onClose={this.closeModal}
      >
        <ModalHeader
          className="edit_cve_modal_header"
        >
          <div className="text">{translate('modal.title.edit_cve')}</div>
          <div className="scan_util_wrap">
            {
              selectedRowIds.length === 0 ? (
                <a
                  className="delete_button util_button"
                  style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                >
                  {translate('modal.button.delete')}
                </a>
              ) : (
                <a
                  className="delete_button util_button"
                  onClick={() => { return this.handleDeleteRowWithRisk(); }}
                  onKeyUp={() => { return this.handleDeleteRowWithRisk(); }}
                >
                  {translate('modal.button.delete')}
                </a>
              )
            }
            <a
              className="add_button util_button"
              onClick={this.handleAddRowWithRisk}
              onKeyUp={this.handleAddRowWithRisk}
            >
              {translate('modal.button.add')}
            </a>
          </div>
          {
            globalErrorClass
            && (
              <div className="header_wrap_error">
                <div
                  className={`error ${globalErrorClass}`}
                >
                  {errorMessage}
                </div>
              </div>
            )
          }
        </ModalHeader>
        <ModalContent scrolling>
          <ModalDescription>
            <AutoSizer disableHeight>
              {({ width }) => {
                return (
                  <Table
                    width={width}
                    height={450}
                    headerHeight={40}
                    rowHeight={40}
                    rowCount={cveList.length}
                    rowGetter={({ index }) => { return cveList[index]; }}
                    rowClassName="table-row"
                  >
                    <Column
                      label=""
                      dataKey=""
                      width={width * 0.05}
                      headerRenderer={() => {
                        return (
                          <span>
                            <Checkbox
                              checked={allSelected}
                              indeterminate={renderIndeterminate()}
                              onChange={this.handleCheckAllChange}
                            />
                          </span>
                        );
                      }}
                      cellRenderer={({ cellData, rowData }) => {
                        return (
                          <Checkbox
                            value={rowData.id}
                            checked={selectedRowIds.indexOf(rowData.id) > -1}
                            onChange={this.handleCheckChange}
                          />
                        );
                      }}
                    />
                    <Column
                      label="Risk"
                      dataKey="risk"
                      width={width * 0.35}
                      headerRenderer={() => {
                        return (
                          <span className="header_title">{translate('list.title.risk_level')}</span>
                        );
                      }}
                      cellRenderer={({ cellData, rowData }) => {
                        return (
                          <span
                            className={cx('risk', {
                              visible: activeIndex === `risk_${rowData.id}`,
                            })}
                          >
                            <Input
                              type="text"
                              disabled={rowData.disabled}
                              value={this.capitalize(rowData.risk)}
                              onChange={(e) => { return this.handleChange(rowData.id, 'risk', e.target.value); }}
                              onFocus={(e) => { return this.handleFocus(rowData.id, 'risk', e.target.value); }}
                              onBlur={() => { return this.handleBlurOnRisk(rowData.id); }}
                            />
                            <ResultRenderer
                              results={riskList}
                              handleResultSelect={this.handleResultSelectWithRisk}
                              isShowResult={activeIndex === `risk_${rowData.id}`}
                              translate={translate}
                            />
                          </span>
                        );
                      }}
                    />
                    <Column
                      label="Code"
                      dataKey="code"
                      width={width * 0.45}
                      headerRenderer={() => {
                        return (
                          <span className="header_title">{translate('list.title.risk_code')}</span>
                        );
                      }}
                      cellRenderer={({ cellData, rowData }) => {
                        return (
                          <span
                            className={cx('code', {
                              visible: activeIndex === `code_${rowData.id}`,
                            })}
                          >
                            <Input
                              type="text"
                              value={rowData.code}
                              onChange={(e) => { return this.handleChange(rowData.id, 'code', e.target.value); }}
                              onFocus={(e) => { return this.handleFocus(rowData.id, 'code', e.target.value); }}
                              onBlur={() => { return this.handleBlurOnCve(rowData.id); }}
                            />
                            <ResultRenderer
                              results={resultList}
                              handleResultSelect={this.handleResultSelect}
                              isShowResult={activeIndex === `code_${rowData.id}`}
                              translate={translate}
                            />
                          </span>
                        );
                      }}
                    />
                    <Column
                      label=""
                      className="icon"
                      dataKey=""
                      width={width * 0.14}
                      headerRenderer={() => {
                        return (
                          <span />
                        );
                      }}
                      cellRenderer={({ cellData, rowData }) => {
                        return (
                          <Icon
                            className="delete_icon"
                            name="delete"
                            onClick={() => { return this.handleDeleteRowWithRisk(rowData.id); }}
                          />
                        );
                      }}
                    />
                  </Table>
                );
              }}
            </AutoSizer>
          </ModalDescription>
        </ModalContent>
        <ModalActions>
          <Button
            className="cancel_button"
            content={translate('contents_header.button.cancel')}
            negative
            onClick={this.closeModal}
          />
          <Button
            className="apply_button"
            icon="check"
            content={translate('contents_header.button.apply')}
            positive
            onClick={this.onSubmit}
          />
        </ModalActions>
      </Modal>
    );
  }
}

export default EditCveCodeModal;
